import script from "./VehicleListingsBestMatches.vue?vue&type=script&lang=js"
export * from "./VehicleListingsBestMatches.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__